export enum ProductRateTypeEnum {
    POWER_PRODUCTION = 'power_production',
    STORAGE_ONLY = 'storage_only',
    SEPARATE_30_YEAR_STORAGE = 'separate_30_year_storage',
    SEPARATE_20_YEAR_STORAGE = 'separate_20_year_storage',
}
